/* NILAYA JADE - mobile conversion safeguards */
(function(){
  function cartCount(){
    const el=document.querySelector('[data-cart-count]');
    if(!el || el.hidden) return 0;
    const value=parseInt(el.textContent || '0',10);
    return Number.isFinite(value) ? value : 0;
  }

  function updateQuantityProgress(){
    const progress=document.querySelector('[data-cart-quantity-progress]');
    if(!progress) return;
    const count=cartCount();
    if(window.cart) window.cart.item_count=count;

    const message=progress.querySelector('[data-cart-quantity-message]');
    const bar=progress.querySelector('[data-cart-quantity-bar]');
    let text='';
    const width=Math.min(count*25,100);

    if(count < 2){
      const missing=2-count;
      text=`Ajoutez encore ${missing} bijou${missing > 1 ? 'x' : ''} pour profiter de -10 %.`;
    } else if(count < 3){
      text='🎉 -10 % débloqués - encore 1 bijou pour passer à -15 %.';
    } else if(count < 4){
      text='🎉 -15 % débloqués - encore 1 bijou pour passer à -20 %.';
    } else {
      text='🎉 -20 % débloqués sur votre sélection.';
    }

    if(message) message.textContent=text;
    if(bar) bar.style.width=`${width}%`;
  }

  function syncStickyPrice(){
    const sticky=document.querySelector('[data-sticky-price]');
    const price=document.querySelector('[data-product-price] [data-price]');
    if(sticky && price) sticky.textContent=price.textContent.trim();
  }

  function syncMobileMenuAria(){
    const menu=document.querySelector('[data-mobile-menu]');
    const toggle=document.querySelector('[data-mobile-toggle]');
    if(!menu || !toggle) return;
    toggle.setAttribute('aria-expanded',menu.classList.contains('is-open') ? 'true' : 'false');
  }

  function harmonizeFranceCopy(){
    document.querySelectorAll('.memory-ad-hero__trust').forEach(el=>{
      if(!el.textContent.includes('en France')){
        el.textContent=el.textContent.replace('Livraison offerte','Livraison offerte en France');
      }
    });
    document.querySelectorAll('[data-mobile-product-sticky] span').forEach(el=>{
      el.textContent='🚚 Offerte en France';
    });
  }

  document.addEventListener('DOMContentLoaded',()=>{
    updateQuantityProgress();
    syncStickyPrice();
    syncMobileMenuAria();
    harmonizeFranceCopy();

    const countEl=document.querySelector('[data-cart-count]');
    if(countEl){
      new MutationObserver(updateQuantityProgress).observe(countEl,{
        childList:true,
        characterData:true,
        subtree:true,
        attributes:true,
        attributeFilter:['hidden']
      });
    }
  });

  document.addEventListener('change',event=>{
    if(event.target.matches?.('[data-option-index]')){
      requestAnimationFrame(syncStickyPrice);
    }
  });

  document.addEventListener('click',()=>{
    setTimeout(syncMobileMenuAria,0);
  });

  document.addEventListener('keydown',event=>{
    if(event.key==='Escape') setTimeout(syncMobileMenuAria,0);
  });
})();
